import React from 'react';

const Favourite = () => {
    return (
        <section className='favourite mb-10'>
        <div className="container mx-auto">
        <h2 className="text-4xl">
        This is Favourite Page
        </h2>
        </div>
    </section>
    );
};

export default Favourite;